import { default as f } from "./vue-editor2.js";
import { default as s } from "./vue-editor3.js";
import { default as n } from "./vue-editor4.js";
import { default as d } from "./vue-editor5.js";
import { default as E } from "./vue-editor6.js";
import { default as i } from "./vue-editor7.js";
import { Constants as e } from "@magnolia/frontend-helpers-base";
import { default as P } from "./vue-editor8.js";
const o = {
  TEMPLATE_ID_PROP: e.TEMPLATE_ID_PROP
};
export {
  i as ComponentHelperService,
  o as Constants,
  f as DefaultFallbackComponent,
  s as EditableArea,
  n as EditableComment,
  d as EditableComponent,
  E as EditablePage,
  P as VueEditorHelper
};
//# sourceMappingURL=vue-editor.js.map
